import EditInvoice from "~/components/Admin/Invoices/EditInvoice"
import { BookerHeader } from "~/components/Camp"
import { InvoicesPaymentStep, useInvoicesPaymentsContext } from "~/contexts/InvoicePaymentsProvider"
import { useState } from "react"
import IInvoice from "~/interfaces/IInvoice"
import { CampingStyleProps, CampProps, SiteProps } from "~/interfaces"
import CustomerPayments from "~/components/Invoices/PublicInvoices/CustomerPayments"
import { Elements } from "@stripe/react-stripe-js"
import ProcessingPayment from "~/components/Invoices/PublicInvoices/ProcessingPayment"

interface CustomerInvoiceContentProps {
  invoice: IInvoice
  email: string
  site: SiteProps
  camp: CampProps
  is_admin: boolean
  camping_style: CampingStyleProps
  is_from_url_shortener?: boolean
  has_pending_payments?: boolean
}

const CustomerInvoiceContent = (props: CustomerInvoiceContentProps) => {
  const [camp, setCamp] = useState<CampProps>(props.camp)
  const { step, stripePromise, stripeOptions } = useInvoicesPaymentsContext()

  const renderContent = () => {
    if (step === InvoicesPaymentStep.payment) {
      return (
        <Elements stripe={stripePromise} options={stripeOptions}>
          <CustomerPayments />
        </Elements>
      )
    }

    if (step === InvoicesPaymentStep.processing) {
      return <ProcessingPayment />
    }

    return (
      <EditInvoice
        invoice={props.invoice}
        disabled={false}
        site={props.site}
        campingStyle={props.camping_style}
        camp={camp}
        setCamp={setCamp}
        customerView
        isInvoicePage
        hasPendingPayments={props.has_pending_payments}
      />
    )
  }

  return (
    <>
      <BookerHeader camp={camp} />
      {renderContent()}
    </>
  )
}

export default CustomerInvoiceContent
